import * as appConstant from "../../constants/appConstant";
import {AsyncSelect} from "@cjdev-internal/visual-stack-x/AsyncSelect";
import React, {useEffect, useState} from "react";

const PublisherSelectionDropdown = (getPublishers, debouncedFetch) => {
    return function PublisherSelectionDropdown({
                                                   selectedAdvertiserFilterList,
                                                   selectedPublisherFilterList,
                                                   setSelectedPublisherFilterList
                                               }) {
        const [noOptionsMessage, setNoOptionsMessage] = useState("");

        const convertSelectedPublisherFilterList = (publisherList) => {
            return publisherList.map((publisher) => ({
                value: publisher.id,
                label: `${publisher.name} (${publisher.id})`,
            }));
        }

        const constructPublisherOptions = async (value) => {

            const advertiserCids = selectedAdvertiserFilterList.map(advertiser => advertiser.value)
            const publisherList = await getPublishers(value, advertiserCids);

            if (publisherList.length <= 0) {
                setNoOptionsMessage(appConstant.NO_MATCHES_FOUND);
                return [];
            } else {
                return convertSelectedPublisherFilterList(publisherList);
            }
        };

        const publisherLoadOptions = (searchTerm) => {
            if (selectedAdvertiserFilterList.length !== 0) {
                if (searchTerm.length > 2) {
                    return debouncedFetch(constructPublisherOptions, searchTerm)
                }
            }
            return new Promise(resolve => resolve(null));
        }

        const publisherFilterChangeHandler = (value) => {
            setSelectedPublisherFilterList(value ? value : [])
        }

        useEffect(() => {
            const isAdvertiserSelected = selectedAdvertiserFilterList.length > 0
            const message = isAdvertiserSelected ? appConstant.TYPE_TO_SEARCH : appConstant.PLEASE_SELECT_ADVERTISER;
            setNoOptionsMessage(message);
        }, [selectedAdvertiserFilterList])

        return (
            <AsyncSelect
                id="publisherSelector"
                components={{DropdownIndicator: null}}
                placeholder={appConstant.PUBLISHER_FILTER_PLACEHOLDER}
                isMulti
                cacheOptions={false}
                isClearable={true}
                isLoading={false}
                loadOptions={publisherLoadOptions}
                noOptionsMessage={() => noOptionsMessage}
                onChange={publisherFilterChangeHandler}
                value={selectedPublisherFilterList}
            />
        )
    }

}
export default PublisherSelectionDropdown;